import { useEffect } from 'react';

export function useScrollLock(isOpen: boolean): void {
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    if (document.body.parentElement) {
      document.body.parentElement.classList.add('modal-open');
    }

    return () => {
      if (document.body.parentElement) {
        document.body.parentElement.classList.remove('modal-open');
      }
    };
  }, [isOpen]);
}
